import { useCallback, useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useUsersTableColumns } from './use-users-table-columns';
import { useBackgroundNavigate, useSearchParams } from '@shared/hooks';
import { UsersTableContext } from '../../context';

export const useUsersTable = () => {
  const { handleFetch, mergeState } = useContext(UsersTableContext);
  const columns = useUsersTableColumns();
  const navigate = useBackgroundNavigate();
  const location = useLocation();
  const { searchParams, remove } = useSearchParams<{ reFetchUsersTable?: string }>();

  useEffect(() => {
    if (location.state?.usersTable?.mergeState) {
      mergeState(location.state.usersTable.mergeState);
    }
  }, [location.state?.usersTable?.mergeState, mergeState]);

  useEffect(() => {
    (async () => {
      if (searchParams.reFetchUsersTable) {
        remove.current('reFetchUsersTable');
        await handleFetch();
      }
    })();
  }, [handleFetch, remove, searchParams.reFetchUsersTable]);

  const getRowProps = useCallback(
    (id: any) => ({
      onDoubleClick: () => navigate(`/users/${id}`, { withBackground: false }),
    }),
    [navigate],
  );

  return { columns, getRowProps };
};
